export const lambdaURLs: Record<string, string> = {
  local: "http://localhost:3012/",
  production: "https://api.topol.io/",
  stage1: "https://s1.api.topol.io/",
  stage2: "https://s2.api.topol.io/",
  stage3: "https://s3.api.topol.io/",
};
